import { createFileRoute } from '@tanstack/react-router';

import { SettingsContainer } from '@/features/settings/containers';

export const Route = createFileRoute('/_layout/settings/_layout')({
  component: SettingsContainer,
});
